/**
 * Converts team size value to readable format (e.g., "5v5")
 * @param {string} teamSize - Team size in format like "10_5_V_5"
 * @returns {string} - Formatted team size like "5v5"
 */
export const formatTeamSize = (teamSize) => {
  if (!teamSize) return "";

  // Extract the team size from format like "10_5_V_5"
  const parts = teamSize.split("_");
  if (parts.length >= 3) {
    const size = parts[1]; // Gets "5" from "10_5_V_5"
    return `${size}v${size}`;
  }

  return teamSize;
};

/**
 * Gets the maximum number of players for a given team size
 * @param {string} teamSize - Team size in format like "10_5_V_5"
 * @returns {number} - Maximum number of players
 */
export const getMaxPlayersFromTeamSize = (teamSize) => {
  if (!teamSize) return 0;

  const parts = teamSize.split("_");
  if (parts.length >= 3) {
    return parseInt(parts[0], 10); // Gets "10" from "10_5_V_5"
  }

  return 0;
};
